export enum ClientStatusEnum {
  Active = 1,
  Credit_Hold,
  Suspended
}
